module.exports = __webpack_public_path__ + "static/ebook.b044f39d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/ebook.webp
// module id = 442
// module chunks = 23899280101116